// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--JZx9d"};